import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

const IncentivesMarketTermsByDefault: FC = () => {
  const { t } = useTranslate();

  return (
    <>
      <div className="nav-secciones mb-4">
        <p className="mb-1 fs-13px text-soft">
          <strong>{t('InThisPage')}</strong>
        </p>
        <ul className="list-unstyled mb-0 fs-13px">
          <li>
            <button
              type="button"
              className="btn btn-link p-0 text-left"
              onClick={() =>
                document
                  .getElementById('oferta-venta')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {t('SellOfferConditionsTitle')}
            </button>
          </li>
          <li>
            <button
              type="button"
              className="btn btn-link p-0 text-left"
              onClick={() =>
                document
                  .getElementById('oferta-compra')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {t('BuyOfferConditionsTitle')}
            </button>
          </li>
          <li>
            <button
              type="button"
              className="btn btn-link p-0 text-left"
              onClick={() =>
                document
                  .getElementById('aceptacion')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {t('AcceptanceConditionsTitle')}
            </button>
          </li>
        </ul>
      </div>

      <div className="card card-bordered">
        <div className="card-inner p-4 p-md-5">
          <section id="oferta-venta" className="anchor-block">
            <h5>{t('SellOfferConditionsTitle')}</h5>
            <p
              dangerouslySetInnerHTML={{
                __html: t('IncentivesMarketSellOfferConditionsIntro'),
              }}
            />

            <h6>{t('OffererRequirements')}</h6>
            <ul className="list mb-4">
              <li>{t('IncentivesMarketSellOfferReq1')}</li>
              <li>{t('IncentivesMarketSellOfferReq2')}</li>
              <li>{t('IncentivesMarketSellOfferReq3')}</li>
            </ul>

            <h6>{t('PublicationEffects')}</h6>
            <ul className="list mb-4">
              <li>{t('IncentivesMarketSellOfferEffect1')}</li>
              <li>{t('IncentivesMarketSellOfferEffect2')}</li>
              <li>{t('IncentivesMarketSellOfferEffect3')}</li>
            </ul>

            <h6>{t('PriceAndPayment')}</h6>
            <p>{t('SellOfferPriceText')}</p>
          </section>

          <hr className="my-4" />

          <section id="oferta-compra" className="anchor-block">
            <h5>{t('BuyOfferConditionsTitle')}</h5>
            <p
              dangerouslySetInnerHTML={{
                __html: t('IncentivesMarketBuyOfferConditionsIntro'),
              }}
            />

            <h6>{t('OffererRequirements')}</h6>
            <ul className="list mb-4">
              <li>{t('IncentivesMarketBuyOfferReq1')}</li>
              <li>{t('IncentivesMarketBuyOfferReq2')}</li>
              <li>{t('IncentivesMarketBuyOfferReq3')}</li>
            </ul>

            <h6>{t('PublicationEffects')}</h6>
            <ul className="list mb-4">
              <li>{t('IncentivesMarketBuyOfferEffect1')}</li>
              <li>{t('IncentivesMarketBuyOfferEffect2')}</li>
              <li>{t('IncentivesMarketBuyOfferEffect3')}</li>
            </ul>

            <h6>{t('OfferedPrice')}</h6>
            <p>{t('BuyOfferPriceText')}</p>
          </section>

          <hr className="my-4" />

          <section id="aceptacion" className="anchor-block">
            <h5>{t('AcceptanceConditionsTitle')}</h5>
            <p
              dangerouslySetInnerHTML={{
                __html: t('IncentivesMarketAcceptanceConditionsIntro'),
              }}
            />

            <h6>{t('AcceptanceEffects')}</h6>
            <ul className="list mb-4">
              <li>{t('IncentivesMarketAcceptanceEffect1')}</li>
              <li>{t('IncentivesMarketAcceptanceEffect2')}</li>
              <li>{t('IncentivesMarketAcceptanceEffect3')}</li>
            </ul>

            <h6>{t('PartyObligations')}</h6>
            <ul className="list mb-4">
              <li>
                <strong>{t('Seller')}:</strong> {t('IncentivesMarketSellerObligation')}
              </li>
              <li>
                <strong>{t('Buyer')}:</strong> {t('BuyerObligation')}
              </li>
              <li>{t('IncentivesMarketTransferObligation')}</li>
            </ul>

            <h6>{t('TaxAndLegalAspects')}</h6>
            <p>{t('IncentivesMarketTaxAndLegalText')}</p>
          </section>

          <hr className="my-4" />

          <p className="text-soft mb-0">
            <em>{t('OfferConditionsDisclaimer')}</em>
          </p>
        </div>
      </div>
    </>
  );
};

export default IncentivesMarketTermsByDefault;
